import styled from '@emotion/styled';
import { Button } from '@mui/material';

export const TopbarWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: #fff;
  box-shadow: 0px 4px 13.6px 0px rgba(0, 0, 0, 0.15);
  gap: 2rem;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1001;
`;
export const LogoWrapper = styled.div`
  cursor: pointer;
  height: 2.56rem;
  img {
    width: 100%;
    height: 100%;
  }
`;
export const LogoutButton = styled(Button)`
  background: #ce0e2d;
  color: #ffffff;
  &:hover,
  &:focus {
    background: #ce0e2d;
  }
`;
